export default __webpack_public_path__ + "static/media/icons8-plus.25eb66fe.svg";